import { Instance, types } from 'mobx-state-tree';

export const State = types.model('State', {
  id: types.identifierNumber,
  name: types.string,
  abbreviation: types.string
});
export type State = Instance<typeof State>;
